export default __webpack_public_path__ + "static/media/Dash.95faa2cd.png";